const Routes = {
    properties: {
        index: '/api/properties',
        store: '/api/properties',
        show: '/api/properties/::ID::',
        update: '/api/properties/::ID::',
        destroy: '/api/properties/::ID::',
    },
};